import { render, staticRenderFns } from "./PluginTable.vue?vue&type=template&id=6485e17e&scoped=true&"
import script from "./PluginTable.vue?vue&type=script&lang=ts&"
export * from "./PluginTable.vue?vue&type=script&lang=ts&"
import style0 from "./PluginTable.vue?vue&type=style&index=0&id=6485e17e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6485e17e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
